package com.kinoshazam.history

data class BrowserLocation(
    val path: String,
    val stateJson: String?,
    val isJoin: Boolean,
)

interface BrowserHistoryPort {
    fun capture(): BrowserLocation
    fun push(path: String, stateJson: String)
    fun replace(path: String, stateJson: String)
    fun back()
    fun listen(onPop: (stateJson: String?) -> Unit): () -> Unit
}

expect fun browserHistoryPort(): BrowserHistoryPort?
